define('views/modules/questionnaire/questions/questions-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/questionnaire/questionnaire',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/questions/questions-content',
    'views/modules/questionnaire/responses/response-list',
    'views/modules/questionnaire/responses/stats/questionnaire-stats',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MQuestionnaire,
    // views
    VBasePanel,
    VQuestionsContent,
    VResponseList,
    VQuestionnaireStats
) {

    var VQuestionsPanel = VBasePanel.extend({
        header: {
            title: "questionnaire:Questions",
            subtitle: 'questionnaire:Questions management'
        },

        tabs: [
            { id: 'questions', title: 'questionnaire:Questions', active: true, callback: 'showQuestions' },
            { id: 'responses', title: 'Results', callback: 'showResponses' },
            // { id: 'stats', title: 'Stats', callback: 'showStats' },
        ],

        content: {
            questions: VQuestionsContent,
            responses: VResponseList,
            stats: VQuestionnaireStats,
        },

        defaultView: 'questions',

        initialize: function(opt) {
            opt = opt || {};
            var model = this.model = new MQuestionnaire(),
                questionsView = this.getView('questions', {
                    model: model,
                    group: opt.group,
                    url: opt.url,
                });

            this.listenTo(questionsView, {
                'form:success': this.close,
                'questionnaire:post': this.onQuestionnairePost,
                'questionnaire:link': this.onQuestionnaireLink
            }).
            listenTo(model, { 'change': this.onModelChange });
        },

        getContentViewOptions: function(opt) {
            return _.extend({
                model: this.model,
            }, this.options);
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        showQuestions: function() { this.showContent('questions'); },
        showResponses: function() { this.showContent('responses'); },

        ////////////
        // events //
        ////////////

        onQuestionnairePost: function(model) {
            this.trigger('questionnaire:post', model);
        },

        onQuestionnaireLink: function(model) {
            this.trigger('questionnaire:link', model);
        },

        onModelChange: function(model) {
            var layout = this.view.layout;
            layout.setTitle(model.getTitle());
        },

    });

    return VQuestionsPanel;
});

